import * as React from 'react';
import { useState } from 'react';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';
import Row from 'react-bootstrap/Row';
import { useLanguage } from '../../../hooks/useLanguage';
import StyledButton from '../../Buttons/StyledButton';
import StyledCol from '../../Cols/StyledCol';
import { StyledFormLabelForInput } from '../../StyledForm/SyledForm';
import { StyledModal } from '../StyledModal/StyledModal';

interface IDoDoubleOptInModal {
    show: boolean;
    username: string;
    password: string;
    onHide: () => void;
    onSubmit: (code: string) => void;
}

export const DoDoubleOptInModal = (props: IDoDoubleOptInModal) => {
    const { t } = useLanguage();

    const [code, setCode] = useState('');

    const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        // const form = event.currentTarget;
        // if (form.checkValidity() === false) {
        //     event.preventDefault();
        //     event.stopPropagation();
        // }
        // {
        //     props.onSubmit();
        // }
        props.onSubmit(code);
    };

    return (
        <StyledModal
            show={props.show}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            backdrop="static"
        >
            <Modal.Header>
                <Modal.Title id="contained-modal-title-vcenter">{t('LOGIN', 'Account aktivieren')}</Modal.Title>
            </Modal.Header>
            <Form className="m-3" noValidate onSubmit={handleSubmit}>
                <Container fluid>
                    <Modal.Body>
                        <Row style={{ padding: 10 }}>
                            <Col>
                                <Form.Group controlId="formGroupPassword">
                                    <StyledFormLabelForInput>
                                        {t(
                                            'LOGIN',
                                            'Geben Sie Ihren Bestätigungscode ein. Dieser Code wird Ihnen per Brief zugesandt.',
                                        )}
                                    </StyledFormLabelForInput>
                                    <Form.Control
                                        autoFocus
                                        type="text"
                                        value={code}
                                        onChange={(e) => setCode(e.target.value)}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                    </Modal.Body>
                    <Modal.Footer>
                        <Container className="mt-4">
                            <Row>
                                <StyledCol paddingLeft="0px" textAlign="left">
                                    <StyledButton variant="secondary" onClick={props.onHide}>
                                        {t('BUTTONS', 'Abbrechen')}
                                    </StyledButton>
                                </StyledCol>
                                <StyledCol paddingRight="0px" textAlign="right">
                                    <StyledButton type="submit">{t('BUTTONS', 'Absenden')}</StyledButton>
                                </StyledCol>
                            </Row>
                        </Container>
                    </Modal.Footer>
                </Container>
            </Form>
        </StyledModal>
    );
};

export default DoDoubleOptInModal;
